import "owl.carousel";
import "whatwg-fetch"; //polyfill pro fetch
require("@fancyapps/fancybox");

export function zobrazSlider() {
  Lc.f("detail.zobrazSlider");

  const url =
    (process.env.NODE_ENV == "development"
      ? "http://rpd-auto.tld"
      : window.location.origin) +
    "/admin/ajax/ajax-fotky-bazar-detail.php/?idVozidla=" +
    $("body").attr("data-vozidlo") +
    "&album=" +
    $("body").attr("data-album");

  //Lc.log("url", url);

  fetch(url)
    .then(res => res.json())
    .then(json => prms_getContainerForVideos(json))
    .catch(error => {
      Lc.ctch(error);
    })
    .then(kod => {
      $("#dvCar").append(kod);

      $("#dvCar").owlCarousel({
        items: 1,
        nav: true,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ],
        dots: false,
        loop: true
      });
    });
}

function prms_getContainerForVideos(json) {
  Lc.promise("prms_getContainerForVideos");
  return new Promise(function(resolve) {
    let fotky = fce.get(json, "fotky") || false;
    if (!fotky) throw "nenalezena žádná videa";

    let $kod = "";

    for (let entry of fotky) {
      let $v = `<img src="${entry.cesta}${entry.obr}">`;
      $v += $("#dvCopy").html();

      $kod += el("div.dvItem", $v);
    }

    // $kod = el("div.dvYvid>.flx", $kod);

    return resolve($kod);
  });
}

export function fotogalerie() {
  $("#dvFotky a").fancybox({
    autoStart: false
  });
}
